export const MAX_CLICKS = 2
export const MAX_PROGRESS = 100
